var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon",class:{'icon--block': _vm.block}},[_c('img',{staticClass:"icon__img",style:({ '--img-size': _vm.size }),attrs:{"src":'/assets/images/icons/' + _vm.fileName,"alt":_vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }